<form
  [formGroup]="updatePackageTypeForm"
  (ngSubmit)="onUpdatePackageType()"
  #pTypeForm
>
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button
        class="main-btn"
        type="submit"
        [ngClass]="{ disabled: !updatePackageTypeForm.valid }"
        [disabled]="!updatePackageTypeForm.valid"
      >
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <h3 class="card-title">Izmeni tip pakovanja</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-6">
          <section class="flex">
            <div class="field w-100 mr-3">
              <label> Oznaka tipa</label>
              <section class="flex align-items-center w-100">
                <input
                  type="text"
                  class="w-100"
                  formControlName="label"
                  pInputText
                />
              </section>
            </div>

            <div class="field w-100">
              <label> Naziv tipa</label>
              <section class="flex align-items-center w-100">
                <input
                  type="text"
                  class="w-100"
                  formControlName="name"
                  pInputText
                />
              </section>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</form>
